import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";

import ViewBranchDetails from "components/ViewBranchDetails/ViewBranchDetails";
import { useFetchBranchDetails, useFetchTenantDetails } from "store/backend/apiHooks";
import Loader from "shared/Icons/Loader/Loader";
import { Visibility, Edit } from "@mui/icons-material";
import { PrimaryButton } from "widgets";
import EditBranchDetails from "components/EditBranchDetails/EditBranchDetails";
import routes from "constants/routes";

import styles from "./BranchDetails.module.scss";

const BranchDetails = () => {
  const [searchParams] = useSearchParams();
  const branchId = searchParams.get("branchId");
  const [editBranch, setEditBranch] = useState(false);
  const { data: branchDetails, isPending: isFetchBranchDetailsLoading } =
    useFetchBranchDetails(branchId);
  const { data: tenantDetails, isPending: isFetchTenantDetailsLoading } =
    useFetchTenantDetails(branchDetails?.tenantId);

  const gradeList = tenantDetails?.gradeIds;
  const allowSingleBranch = tenantDetails?.hasSingleBranch;

  if (isFetchBranchDetailsLoading || isFetchTenantDetailsLoading) {
    return (
      <div className={styles.mainContainer}>
        <div
          className={styles.loadingWrap}
          role="status"
          aria-live="polite"
          aria-busy="true"
        >
          <Loader inline />
        </div>
      </div>
    );
  }

  const tenantDetailsUrl = branchDetails?.tenantId
    ? `${routes.tenantDetails.tenantDetails}?tenantId=${branchDetails.tenantId}`
    : routes.tenants.tenants;

  return (
    <div className={styles.mainContainer}>
      <div className={styles.toolbar}>
        <Link className={styles.backLink} to={tenantDetailsUrl}>
          ← Back to tenant
        </Link>
        <h1 className={styles.pageTitle}>
          {editBranch ? "Edit branch details" : "Branch details"}
        </h1>
        <PrimaryButton onClick={() => setEditBranch(!editBranch)}>
          {editBranch ? "View branch" : "Edit branch"}
          {editBranch ? (
            <Visibility className={styles.icon} />
          ) : (
            <Edit className={styles.icon} />
          )}
        </PrimaryButton>
      </div>
      <div className={styles.branchDetailsContent}>
        {editBranch ? (
          <EditBranchDetails
            branchDetails={branchDetails}
            branchId={branchId}
            existingGradeIds={gradeList}
            tenantCountryId={
              tenantDetails?.countryId || tenantDetails?.country_id
            }
          />
        ) : (
          <ViewBranchDetails
            branchDetails={branchDetails}
            allowSingleBranch={allowSingleBranch}
            gradeList={gradeList}
            tenantCountryId={
              tenantDetails?.countryId || tenantDetails?.country_id
            }
          />
        )}
      </div>
    </div>
  );
};

export default BranchDetails;
